import vsbl from 'vsbl'

export default value => {
  const subtitle = value.querySelector('.js-subtitle')
  const title = value.querySelector('.js-title')
  const circle = value.querySelector('.js-moment-circle')
  const line = value.querySelector('.js-moment-line')
  vsbl(subtitle)(() => {
    subtitle.classList.add('is-visible')
  })

  vsbl(title)(() => {
    title.classList.add('is-visible')
  })

  vsbl(circle)(() => {
    circle.classList.add('is-visible')
  })

  vsbl(line)(() => {
    line.classList.add('is-visible')
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/value-prop.js